import {
  createSlice,
  createEntityAdapter,
  createAsyncThunk,
  createSelector
} from '@reduxjs/toolkit'


import userService from '../services/userService'

export const fetchAllUsers = createAsyncThunk('user/fetchAllUsers', 
  async () => {
    const response = await userService.fetchAll()
    //console.log(response)
    return response.data
})

export const fetchUser = createAsyncThunk('user/fetchUser', 
  async (id) => {
    const response = await userService.fetch(id)
    return response.data
})
export const createUser = createAsyncThunk('user/createUser', 
  async (user) => {
    const response = await userService.create(user)
    return response.data
})
export const updateUser = createAsyncThunk('user/updateUser', 
  async (user) => {
    const response = await userService.update(user)
    return response.data
})
export const deleteUser = createAsyncThunk('user/deleteUser', 
  async (id) => {
    const response = await userService.delete(id)
    return response.data
})


const addVCols = (x)=>x

const userAdapter = createEntityAdapter({
  selectId: (entity) => entity.userName,
  sortComparer: (a, b) => a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase())
  
  //sortComparer: (a, b) => (a.fullNameid - b.id)
})

const initialState = userAdapter.getInitialState({
  status: 'idle',
  error: null
  });


const userSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    usersSyncLoaded: {
      reducer(state, action) {
        userAdapter.setAll(state, action.payload)
      },
      prepare(userList) {
        return {payload:userList}
      }
    },
    clearUsers(state, action) {
        state.error=null
        state.status='idle'
        userAdapter.removeAll(state)
    }
  },
  extraReducers(builder) {
    builder
      .addCase(fetchAllUsers.pending, (state, action) => {
        state.status = 'loading'
        state.error=null
      })
      .addCase(fetchAllUsers.fulfilled, (state, action) => {
        
        
        state.status = 'succeeded'
        if (action.payload) action.payload.forEach( addVCols);
        userAdapter.setAll(state, action.payload)
        //alert(312300)
        console.error(action.payload);
      })
      .addCase(fetchAllUsers.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        if (action.payload) addVCols(action.payload, 0)
        userAdapter.upsertOne(state, action.payload)
      })
      .addCase(createUser.fulfilled, (state, action) => {
        if (action.payload) addVCols(action.payload, 0)
        userAdapter.addOne(state,action.payload)
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        if (action.payload) addVCols(action.payload, 0)
        userAdapter.upsertOne(state , action.payload)
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        // alert("action="+action)
        // alert(action.payload)
        userAdapter.removeOne(state,action.payload)
      })
  }
})



export const { clearUsers, usersSyncLoaded } = userSlice.actions

export default userSlice.reducer;

export const {
  selectAll:  selectAllUsers,
  selectById: xselectUserById,
  selectIds:  selectUserIds,
} = userAdapter.getSelectors((state) => state.user)

export const selectUserById = (id)=>(state)=>xselectUserById(state, id)
export const selectUserStatus = (state)=>state.user.status;
export const selectUserError = (state)=>state.user.error;

export const selectAllHosts = 
createSelector(
  [	selectAllUsers],
  (users) =>users.filter(u=>'HOST'===u.roles)
)


export const selectAllUsernames = 
createSelector(
  [	selectAllUsers],
  (users) =>users.map(u=>u.userName)
)




const filterPredicate =(r, f)=>{
  if (!Boolean(f)) return true;
  return r.userName.toLowerCase().includes(f);
} 

export const selectUserIdsByFilter = 
createSelector( 
  [	selectAllUsers, 	(state, filter)=>(filter?filter.toLowerCase():'')],
  (u, fff) =>u.filter( v=>filterPredicate(v, fff) ).map(x=>x.id)
)



